export const locales = {
    "no": {
        "language-header": "Språk",
        "language-no": "Norsk",
        "language-en": "Engelsk",
        "header-title": "Azure Resource Scheduler",
        "header-admin-title": "Admin",
        "header-admin-resources": "Ressurser",
        "header-admin-environments": "Miljøer",
        "header-admin-jobs": "Jobber",
        "header-admin-docs": "Dokumentasjon",
        "header-admin-profile": "Profil",
        "header-admin-login": "Logg inn",
        "header-admin-logout": "Logg ut"
    }
};